import { render, staticRenderFns } from "./OnePagerPdfDialog.vue?vue&type=template&id=483b4f92&scoped=true&"
import script from "./OnePagerPdfDialog.vue?vue&type=script&lang=js&"
export * from "./OnePagerPdfDialog.vue?vue&type=script&lang=js&"
import style0 from "./OnePagerPdfDialog.vue?vue&type=style&index=0&id=483b4f92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b4f92",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCarousel,VCarouselItem,VChip,VIcon,VImg,VSpacer})
